/** Links stored in rich text may open outside Calque; accept only ordinary destinations. */
export function safeRichTextHref(raw: string): string | null {
  const value = raw.trim();
  if (!value || value.length > 2048 || /[\u0000-\u001f\u007f]/.test(value))
    return null;
  try {
    const url = new URL(value);
    if (
      (url.protocol === "http:" || url.protocol === "https:") &&
      !url.username &&
      !url.password
    )
      return url.href;
    if (
      url.protocol === "mailto:" &&
      url.pathname &&
      !/[\s]/.test(url.pathname)
    )
      return url.href;
  } catch {
    /* Invalid or relative URL. */
  }
  return null;
}
